import type { ModuleRegister } from '@sdk';

const loaders = import.meta.glob<{ default: ModuleRegister }>('../modules/*/client/index.ts');

export async function loadModuleClient(id: string): Promise<ModuleRegister> {
  const key = Object.keys(loaders).find((k) => k.includes(`/modules/${id}/`));
  if (!key || !loaders[key]) {
    throw new Error(`No client entry for module "${id}"`);
  }
  const mod = await loaders[key]();
  return mod.default;
}
